import { Component } from "react";

// Keeps a crashing legacy card from taking down the whole desktop page.
// Remount it per case (key={caseId}) to reset.
class PanelErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="ds-panel-placeholder ds-panel-error">
        Δεν ήταν δυνατή η εμφάνιση των στοιχείων σε αυτό το πλαίσιο.
        {this.props.fallback}
      </div>
    );
  }
}

export default PanelErrorBoundary;
